
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-02-23-supabase-todo-app-team-with-functions",
      function () {
        return require("private-next-pages/blogs/2025-02-23-supabase-todo-app-team-with-functions/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-02-23-supabase-todo-app-team-with-functions"])
      });
    }
  